module.exports = __webpack_public_path__ + "static/21-Sagemcom-6e6fa8d610cc1663bec177fe5418c35a.png";